import axios from "axios";

export default {
  namespaced: true,
  state: {
    brands: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    brandsMessage: ''
  },
  mutations: {
    RECEIVED_BRANDS(state, payload) {
      state.brands = payload;
      state.isReceiving = false;
    },
    RECEIVING_BRANDS(state) {
      state.isReceiving = true;
    },
    RECEIVED_BRAND(state, payload) {
      state = Object.assign(state, {
        brands: [...state.brands, payload],
        isReceiving: false,
      })
    },
    RECEIVING_BRAND(state) {
      state.isReceiving = true;
    },
    UPDATED_BRAND(state, payload) {
      let index = state.brands.findIndex(brand => brand._id === payload._id);
      state = Object.assign(state, {
        brands: state.brands.map((brand, i) => {
          if (i === index) {
            return Object.assign({}, brand, payload);
          }
          return brand;
        }),
        isUpdating: false,
        brandsMessage: 'Brands has been updating!',
      })
    },
    UPDATING_BRAND(state) {
      state.isUpdating = true;
    },
    DELETED_BRAND(state, payload) {
      let indexToDelete = state.brands.findIndex(brand => brand._id === payload._id);
      let brands = [...state.brands];
      brands.splice(indexToDelete, 1);
      state = Object.assign(state, {
        brands: [...brands],
        isDeleting: false,
        idToDelete: null,
        brandsMessage: 'Brand has been Deleted!',
      });
    },
    DELETING_BRAND(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteBrandRequest({dispatch}, payload) {
      dispatch("deletingBrand", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/brand/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteBrand", {_id: payload._id});
      })
    },
    getBrandsRequest({dispatch}) {
      dispatch("receivingBrands");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/brands';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveBrands", res.data);
      })
    },
    async insertBrandRequest({dispatch}, payload) {
      dispatch("receivingBrands");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/brand/';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response=>{
        dispatch("receiveBrand", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertBrandWithImageRequest({dispatch}, payload) {
      dispatch("receivingBrands");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/brand/';
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('image', payload.brandimage, payload.imagename); 
      delete payload['brandimage'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        dispatch("receiveBrand", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    updateBrandRequest({dispatch}, payload) {
      dispatch("updatingBrand");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/brand/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(response => {
        dispatch("updateBrand", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    updateBrandImageRequest({dispatch}, payload) {
      dispatch("updatingBrand");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/brand/image/' + id;
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      let data = new FormData();

      data.append('image', payload.brandimage, payload.imagename); 
      delete payload['brandimage'];
      for (let x in payload) data.append(x, payload[x]);

      axios({method: "put", url: url, headers: headers, data: data})
      .then(response => {
        dispatch("updateBrand", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    receiveBrands({commit}, payload) {
      commit("RECEIVED_BRANDS", payload)
    },
    receivingBrands({commit}) {
      commit("RECEIVING_BRANDS")
    },
    receiveBrand({commit}, payload) {
      commit("RECEIVED_BRAND", payload)
    },
    receivingBrand({commit}) {
      commit("RECEIVING_BRAND")
    },
    updateBrand({commit}, payload) {
      commit("UPDATED_BRAND", payload)
    },
    updatingBrand({commit}) {
      commit("UPDATING_BRAND")
    },
    deleteBrand({commit}, payload) {
      commit("DELETED_BRAND", payload)
    },
    deletingBrand({commit}, payload) {
      commit("DELETING_BRAND", payload)
    }
  },
};
